 <template>
  <v-dialog v-model="dialog" max-width="750" persistent>
    <v-card class="pt-2 pl-0 pr-0">
      <v-card-title
        class="headline-6"
        :class="{ 'subtitle-2': $vuetify.breakpoint.xs }"
        style="word-break: normal; !important"
      >
        {{
          modalidade && !modalidade.id
            ? $vuetify.lang.t("$vuetify.NOVA_MODALIDADE")
            : $vuetify.lang.t("$vuetify.ATUALIZANDO_MODALIDADE")
        }}
      </v-card-title>

      <v-form ref="form" lazy-validation class="overflow-y-auto">
        <v-list class="ma-0 pa-0" max-height="450" min-height="450">
          <v-row class="ma-0 d-flex justify-center mb-n3">
            <v-row class="row ma-0 ml-5 pa-0">
              <v-col>
                <span class="subtitle-2" style="word-break: normal; !important">
                  {{ $vuetify.lang.t("$vuetify.DADOS_GERAIS") }}
                </span>
              </v-col>
            </v-row>

            <v-row class="justify-center ma-0">
              <v-col cols="3" class="ml-n2 mr-8">
                <v-row>
                  <span
                    class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
                  >
                    {{ '*' + $vuetify.lang.t("$vuetify.CONTRATO") }}:</span
                  >
                </v-row>
                <v-row md="2">
                  <v-select
                    :items="contracts"
                    v-model="modalidade.contrato"
                    solo
                    dense
                    return-object
                    item-text="nome"
                    :rules="[
                      (v) =>
                        !!v || $vuetify.lang.t('$vuetify.CAMPO_OBRIGATORIO'),
                    ]"
                  ></v-select>
                </v-row>
              </v-col>

              <v-col cols="2" class="ml-n2 mr-6">
                <v-row>
                  <span
                    class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
                  >
                    {{ '*' + $vuetify.lang.t("$vuetify.MODALIDADE") }}:</span
                  >
                </v-row>
                <v-row md="2">
                  <v-text-field
                    v-model.trim="modalidade.modalidade"
                    dense
                    single-line
                    solo
                    max-width="200"
                    :rules="rules"
                  ></v-text-field>
                </v-row>
              </v-col>

              <v-col cols="4" class="mr-n2">
                <v-row>
                  <span
                    class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
                  >
                    {{ '*' + $vuetify.lang.t("$vuetify.DESCRICAO") }}:</span
                  >
                </v-row>
                <v-row md="2">
                  <v-text-field
                    v-model.trim="modalidade.descricao"
                    dense
                    single-line
                    solo
                    max-width="200"
                    :rules="rules"
                  ></v-text-field>
                </v-row>
              </v-col>
            </v-row>

            <v-row class="justify-center ma-0 mt-n2 ml-n3">
              <v-col cols="2" class="ml-10 mr-8">
                <v-row>
                  <span
                    class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
                  >
                    {{ $vuetify.lang.t("$vuetify.VALOR_LOCACAO") }}:</span
                  >
                </v-row>
                <v-row md="2">
                  <v-currency-field
                    v-model.trim="modalidade.valorLocacao"
                    dense
                    single-line
                    solo
                    max-width="200"
                    :prefix="$getCurrencySymbol(modalidade.contrato?modalidade.contrato.moeda:null, true)"
                    locale="pt-BR"
                  ></v-currency-field>
                </v-row>
              </v-col>

              <v-col cols="2" class="ml-n2 mr-8">
                <v-row>
                  <span
                    class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
                  >
                    {{ $vuetify.lang.t("$vuetify.VALOR_ASSISTENCIA") }}:</span
                  >
                </v-row>
                <v-row md="2">
                  <v-currency-field
                    v-model.trim="modalidade.valorAssistencia"
                    dense
                    single-line
                    solo
                    max-width="200"
                    :prefix="$getCurrencySymbol(modalidade.contrato?modalidade.contrato.moeda:null, true)"
                    locale="pt-BR"
                  ></v-currency-field>
                </v-row>
              </v-col>

              <v-col cols="2" class="ml-n2 mr-6">
                <v-row>
                  <span
                    class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
                  >
                    {{ $vuetify.lang.t("$vuetify.VALOR_TELECOM") }}:</span
                  >
                </v-row>
                <v-row md="2">
                  <v-currency-field
                    v-model.trim="modalidade.valorTelecom"
                    dense
                    single-line
                    solo
                    max-width="200"
                    :prefix="$getCurrencySymbol(modalidade.contrato?modalidade.contrato.moeda:null, true)"
                    locale="pt-BR"
                  ></v-currency-field>
                </v-row>
              </v-col>

              <v-col cols="3" class="mt-n3 ml-n3">
                <v-row>
                  <v-checkbox
                    :input-value="bandaRede"
                    v-model="modalidade.bandaRede"
                    color="blue darken-2"
                    dense
                    :value="bandaRede"
                    class="ml-7"
                    :label="$vuetify.lang.t('$vuetify.BANDA_PELA_REDE')"
                  ></v-checkbox>
                </v-row>

                <v-row class="mt-n6">
                  <v-checkbox
                    :input-value="demonstracao"
                    v-model="modalidade.demonstracao"
                    color="blue darken-2"
                    dense
                    :value="demonstracao"
                    class="ml-7"
                    :label="$vuetify.lang.t('$vuetify.DEMONSTRACAO')"
                  ></v-checkbox>
                </v-row>
              </v-col>
            </v-row>
          </v-row>

          <v-row class="ma-0 d-flex justify-center mb-n3">
            <v-row class="row ma-0 ml-6 pa-0">
              <v-col>
                <span class="subtitle-2" style="word-break: normal; !important">
                  {{ $vuetify.lang.t("$vuetify.TAXAS_VELOCIDADE") }}
                </span>
              </v-col>
            </v-row>

            <v-row class="ma-0 pl-0 justify-center">
              <v-col cols="2" class="ml-n2 mr-8">
                <v-row>
                  <span
                    class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
                  >
                    {{
                      $vuetify.lang.t("$vuetify.DOWNLOAD_MAXIMO_CONTRATADO")
                    }}:</span
                  >
                </v-row>
                <v-row md="2">
                  <v-text-field
                    v-model.trim="modalidade.downloadContratado"
                    dense
                    single-line
                    solo
                    max-width="200"
                    type="number"
                  ></v-text-field>
                </v-row>
              </v-col>

              <v-col cols="2" class="ml-n2 mr-6">
                <v-row>
                  <span
                    class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
                  >
                    {{
                      $vuetify.lang.t("$vuetify.DOWNLOAD_TIPICO_CONTRATADO")
                    }}:</span
                  >
                </v-row>
                <v-row md="2">
                  <v-text-field
                    v-model.trim="modalidade.downloadTipico"
                    dense
                    single-line
                    solo
                    max-width="200"
                    type="number"
                  ></v-text-field>
                </v-row>
              </v-col>

              <v-col cols="2" class="mr-6">
                <v-row>
                  <span
                    class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
                  >
                    {{
                      $vuetify.lang.t("$vuetify.UPLOAD_MAXIMO_CONTRATADO")
                    }}:</span
                  >
                </v-row>
                <v-row md="2">
                  <v-text-field
                    v-model.trim="modalidade.uploadContratado"
                    dense
                    single-line
                    solo
                    max-width="200"
                    type="number"
                  ></v-text-field>
                </v-row>
              </v-col>

              <v-col cols="2" class="mr-n2">
                <v-row>
                  <span
                    class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
                  >
                    {{
                      $vuetify.lang.t("$vuetify.UPLOAD_TIPICO_CONTRATADO")
                    }}:</span
                  >
                </v-row>
                <v-row md="2">
                  <v-text-field
                    v-model.trim="modalidade.uploadTipico"
                    dense
                    single-line
                    solo
                    max-width="200"
                    type="number"
                  ></v-text-field>
                </v-row>
              </v-col>
            </v-row>

            <v-row class="ma-0 mt-n2 pl-0 justify-center">
              <v-col cols="2" class="ml-n2 mr-8">
                <v-row>
                  <span
                    class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
                  >
                    {{
                      $vuetify.lang.t("$vuetify.DOWNLOAD_MAXIMO_PROJETADO")
                    }}:</span
                  >
                </v-row>
                <v-row md="2">
                  <v-text-field
                    v-model.trim="modalidade.downloadProjetado"
                    dense
                    single-line
                    solo
                    max-width="200"
                    type="number"
                  ></v-text-field>
                </v-row>
              </v-col>

              <v-col cols="2" class="ml-n2 mr-6">
                <v-row>
                  <span
                    class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
                  >
                    {{
                      $vuetify.lang.t("$vuetify.DOWNLOAD_CIR_PROJETADO")
                    }}:</span
                  >
                </v-row>
                <v-row md="2">
                  <v-text-field
                    v-model.trim="modalidade.downloadCir"
                    dense
                    single-line
                    solo
                    max-width="200"
                    type="number"
                  ></v-text-field>
                </v-row>
              </v-col>

              <v-col cols="2" class="mr-6">
                <v-row>
                  <span
                    class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
                  >
                    {{
                      $vuetify.lang.t("$vuetify.UPLOAD_MAXIMO_PROJETADO")
                    }}:</span
                  >
                </v-row>
                <v-row md="2">
                  <v-text-field
                    v-model.trim="modalidade.uploadProjetado"
                    dense
                    single-line
                    solo
                    max-width="200"
                    type="number"
                  ></v-text-field>
                </v-row>
              </v-col>

              <v-col cols="2" class="mr-n2">
                <v-row>
                  <span
                    class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
                  >
                    {{
                      $vuetify.lang.t("$vuetify.UPLOAD_CIR_PROJETADO")
                    }}:</span
                  >
                </v-row>
                <v-row md="2">
                  <v-text-field
                    v-model.trim="modalidade.uploadCir"
                    dense
                    single-line
                    solo
                    max-width="200"
                    type="number"
                  ></v-text-field>
                </v-row>
              </v-col>
            </v-row>

            <v-row class="ma-0 mt-n2 ml-11">
              <v-col cols="2" class="mr-0 ml-11 pl-3">
                <v-row>
                  <span
                    class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
                  >
                    {{ '*' + $vuetify.lang.t("$vuetify.MEDIDA") }}:</span
                  >
                </v-row>
                <v-row md="2">
                  <v-select
                    :items="metrics"
                    v-model="modalidade.medida"
                    solo
                    dense
                    :rules="rules"
                  ></v-select>
                </v-row>
              </v-col>
            </v-row>
          </v-row>

          <v-row class="ma-0 d-flex justify-center mb-n3">
            <v-row class="ma-0 ml-8 pa-0">
              <v-col>
                <span class="subtitle-2" style="word-break: normal; !important">
                  {{ $vuetify.lang.t("$vuetify.OUTROS") }}
                </span>
              </v-col>
            </v-row>

            <v-col cols="12">
              <v-row class="ma-0 justify-center ml-9">
                <v-col cols="4" class="mt-n3">
                  <v-checkbox
                    :input-value="internet"
                    v-model="modalidade.internet"
                    color="blue darken-2"
                    dense
                    :value="internet"
                    class="ml-7"
                    label="Internet"
                  ></v-checkbox>
                </v-col>

                <v-col cols="4" class="mt-n3 ml-n3">
                  <v-checkbox
                    :input-value="intranet"
                    v-model="modalidade.intranet"
                    color="blue darken-2"
                    dense
                    :value="intranet"
                    class="ml-7"
                    label="Intranet"
                  ></v-checkbox>
                </v-col>

                <v-col cols="4" class="mt-n3 ml-n3">
                  <v-checkbox
                    :input-value="voip"
                    v-model="modalidade.voip"
                    color="blue darken-2"
                    dense
                    :value="voip"
                    class="ml-7"
                    label="Voip"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-row class="ma-0 ml-n2 justify-center">
                <v-col cols="4" class="mt-n3 mr-n3 ml-n3">
                  <v-checkbox
                    :input-value="gerencia"
                    v-model="modalidade.gerencia"
                    color="blue darken-2"
                    dense
                    :value="gerencia"
                    class="ml-7"
                    :label="$vuetify.lang.t('$vuetify.GERENCIA')"
                  ></v-checkbox>
                </v-col>

                <v-col cols="4" class="mt-n3 ml-n3">
                  <v-checkbox
                    :input-value="iptv"
                    v-model="modalidade.iptv"
                    color="blue darken-2"
                    dense
                    :value="iptv"
                    class="ml-7"
                    label="IPTV"
                  ></v-checkbox>
                </v-col>

                <v-col cols="2" class="ml-n2 mr-8">
                  <v-row>
                    <span
                      class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
                    >
                      {{ $vuetify.lang.t("$vuetify.OUTROS") }}:</span
                    >
                  </v-row>
                  <v-row md="2">
                    <v-text-field
                      v-model.trim="modalidade.outros"
                      dense
                      single-line
                      solo
                      max-width="200"
                    ></v-text-field>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-list>
      </v-form>

      <v-divider></v-divider>

      <v-card-actions>
        <v-lazy :options="{ threshold: 0.6 }" transition="slide-x-transition">
          <span
            class="ml-4 caption red--text"
            v-show="showModalidadeAlreadyExists"
            >{{ $vuetify.lang.t("$vuetify.JA_EXISTE_MODALIDADE") }}</span
          >
          <span class="ml-4 caption red--text" v-if="showWarning"
            >{{ warningMessage }}
          </span>
        </v-lazy>

        <v-lazy :options="{ threshold: 0.6 }" transition="slide-x-transition">
          <span class="ml-4 caption red--text" v-show="showWarning"
            >{{ warningMessage }}
          </span>
        </v-lazy>

        <v-spacer></v-spacer>
        <v-btn color="blue darken-2" text @click="$root.$emit('close-dialog'); close()">
          {{ $vuetify.lang.t("$vuetify.CANCELAR") }}
        </v-btn>
        <v-btn
          color="blue darken-2"
          text
          @click="$refs.form.validate(); send(modalidade)"
          :loading="isLoading"
        >
          {{ $vuetify.lang.t("$vuetify.ENVIAR") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},
  props: {
    close: Function,
    dialog: Boolean,
    color: String,
    send: Function,
    modalidade: Object,
    isLoading: Boolean,
    showModalidadeAlreadyExists: Boolean,
    warningMessage: String,
    showWarning: Boolean,
  },
  methods: {},
  data() {
    return {
      bandaRede: false,
      demonstracao: false,
      voip: false,
      iptv: false,
      gerencia: false,
      intranet: false,
      internet: false,
      selectedContract: undefined,
      contracts: [],
      metrics: [],
      rules: [
        (v) =>
          (v && v.trim().length >= 1) ||
          this.$vuetify.lang.t("$vuetify.CAMPO_OBRIGATORIO"),
      ],
    };
  },
  created: function () {
    this.$root.$on("invalidateFields", () => {});

    this.$get("/contrato/all", {}).then((response) => {
      this.contracts = response.data;
    });

    this.metrics = ["Kbps", "Mbps", "Gbps"];
  },
};
</script>